import { useRouterState } from "@tanstack/react-router"
import { type PropsWithChildren, type ReactNode, useContext } from "react"
import { Toaster } from "sonner"

import { GlobalLoader } from "@/components/Loader/GlobalLoader.tsx"
import { useMediaQuery } from "@/hooks/useMediaQuery.ts"
import { useRootContext } from "@/hooks/useRootContext.ts"
import { NavigationBar } from "@/routes/auth/NavigationBar.tsx"
import { PageBackground, PageContainer, PageContent } from "@/routes/auth/PageStyles.ts"
import { TaskViewModelContext } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"
import { mobileBreakpoint } from "@/styles/mixins.ts"

import type { Property } from "csstype"

type PageProps = PropsWithChildren & {
  orgPage?: boolean,
  withMainMenu?: boolean,
  withUserMenu?: boolean,
  backgroundGradient?: Property.Background,
  mainMenuBuilder?: ReactNode,
}

export const Page = (props: PageProps) => {
  const state = useRouterState()
  const context = useRootContext()

  const isMobile = useMediaQuery(mobileBreakpoint)
  const taskViewModel = useContext(TaskViewModelContext)

  const twoPaneLayout = !isMobile && taskViewModel != null

  return (
    <>
      {context.useLoader && <GlobalLoader />}

      <PageContainer>
        <NavigationBar
          state={state}
          orgPage={props.orgPage}
          withMainMenu={props.withMainMenu}
          withUserMenu={props.withUserMenu}
          mainMenuBuilder={props.mainMenuBuilder}
        />

        <PageContent twoPaneLayout={twoPaneLayout}>
          {props.children}
        </PageContent>

        <Toaster richColors theme="system" toastOptions={{ closeButton: true, duration: 10000 }} />
      </PageContainer>

      <PageBackground background={props.backgroundGradient} />
    </>
  )
}
